import { Button, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const TableSearchNoMatch = ({
  heading,
  searchedIn,
  foundElsewhere,
  filtersNote,
  onClearSearch,
  onResetFilters,
}: {
  heading: string;
  searchedIn: string;
  foundElsewhere: string;
  filtersNote: string | null;
  onClearSearch: () => void;
  onResetFilters: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Flex direction="column" align="center" gap="2" py="10" px="4" textAlign="center" data-testid="table-search-no-match">
      <Text fontWeight="semibold">{heading}</Text>
      <Text color="smMuted" fontSize="sm">
        {searchedIn}
      </Text>
      <Text color="smMuted" fontSize="sm">
        {foundElsewhere}
      </Text>
      {filtersNote && (
        <Text color="smMuted" fontSize="sm">
          {filtersNote}
        </Text>
      )}
      <Flex gap="3" pt="2" wrap="wrap" justify="center">
        <Button size="sm" variant="outline" colorScheme="gray" color="smMuted" onClick={onClearSearch}>
          {t("Clear the search")}
        </Button>
        {filtersNote && (
          <Button size="sm" variant="outline" colorScheme="gray" color="smMuted" onClick={onResetFilters}>
            {t("Reset filters")}
          </Button>
        )}
      </Flex>
    </Flex>
  );
};
